import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockTitleFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 *
 * Lazy per the block-loading rule: every block is code-split. The block's HTML
 * is still server-rendered (Suspense resolves async components during SSR), so
 * first paint is unaffected — only hydration waits on this chunk.
 */
export const titleBlockConfig = {
  name: 'inner-block-title',
  component: defineAsyncComponent(() => import('./CmsTitleBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./TitleBlock.vue')),
  fields: blockTitleFields,
} satisfies ModularBlockConfig;
